import { makeAutoObservable, runInAction } from 'mobx';
import agent from '../api/agent';
import { EmailNew } from '../models/EmailNew';
import { toast } from 'react-toastify';

export default class EmailStore {
  emailRegistry = new Map<string, EmailNew>();
  loadingInitial = false;

  emailMessageDetails: {
    isloading: boolean;
    pageNumber: number;
    count: number;
    data: [];
  } = {
    count: 0,
    isloading: false,
    pageNumber: 1,
    data: [],
  };
  emailAlertDetails: {
    isloading: boolean;
    pageNumber: number;
    count: number;
    data: [];
  } = {
    count: 0,
    isloading: false,
    pageNumber: 1,
    data: [],
  };

  constructor() {
    makeAutoObservable(this);
  }
  get emailitemsByDate() {
    return Array.from(this.emailRegistry.values());
  }
  setLoadingInitial = (state: boolean) => {
    this.loadingInitial = state;
  };

  private setEmail = (Email: EmailNew) => {
    this.emailRegistry.set(Email.id, Email);
  };

  loadEmails = async () => {
    this.loadingInitial = true;
    try {
      const emailDetails = await agent.email.list();
      runInAction(() => {
        emailDetails.forEach((emailDetail: EmailNew) => {
          this.setEmail(emailDetail);
        });
      });
      this.setLoadingInitial(false);
    } catch (error) {
      runInAction(() => {
        console.log(error);
        this.setLoadingInitial(false);
      });
    }
  };

  // email message
  emailMessageSearch = async (searchvalue: string, PageNumber: number) => {
    try {
      this.emailMessageDetails = {
        ...this.emailMessageDetails,
        isloading: true,
      };
      let [searchDetails, countDetails] = await Promise.all([
        agent.email.emailMessageSearchAPI({
          item: searchvalue,
          PageNumber,
          PageSize: 5,
        }),
        agent.email.emailMessageCountAPI({
          item: searchvalue,
        }),
      ]);
      runInAction(() => {
        this.emailMessageDetails = {
          ...this.emailMessageDetails,
          count: countDetails.data,
          data: searchDetails.data,
          isloading: false,
          pageNumber: PageNumber,
        };
      });
    } catch (error) {
      this.emailMessageDetails = {
        ...this.emailMessageDetails,
        isloading: false,
      };
    }
  };

  emailMessageSort = async (
    orderBy: string,
    name: string,
    PageNumber: number,
  ) => {
    try {
      this.emailMessageDetails = {
        ...this.emailMessageDetails,
        isloading: true,
      };
      let searchDetails = await agent.email.emailMessageSortAPI({
        orderBy,
        name,
        PageNumber,
        PageSize: 5,
      });
      runInAction(() => {
        this.emailMessageDetails = {
          ...this.emailMessageDetails,
          data: searchDetails.data,
          isloading: false,
        };
      });
    } catch (error) {
      this.emailMessageDetails = {
        ...this.emailMessageDetails,
        isloading: false,
      };
    }
  };

  // email alert
  emailAlertSearch = async (searchvalue: string, PageNumber: number) => {
    try {
      this.emailAlertDetails = {
        ...this.emailAlertDetails,
        isloading: true,
      };
      let [searchDetails, countDetails] = await Promise.all([
        agent.email.emailAlertSearchAPI({
          item: searchvalue,
          PageNumber,
          PageSize: 5,
        }),
        agent.email.emailAlertCountAPI({
          item: searchvalue,
        }),
      ]);
      runInAction(() => {
        this.emailAlertDetails = {
          ...this.emailAlertDetails,
          count: countDetails.data,
          data: searchDetails.data,
          isloading: false,
          pageNumber: PageNumber,
        };
      });
    } catch (error) {
      this.emailAlertDetails = {
        ...this.emailAlertDetails,
        isloading: false,
      };
    }
  };

  emailAlertSort = async (
    orderBy: string,
    name: string,
    PageNumber: number,
  ) => {
    try {
      this.emailAlertDetails = {
        ...this.emailAlertDetails,
        isloading: true,
      };
      let searchDetails = await agent.email.emailAlertSortAPI({
        orderBy,
        name,
        PageNumber,
        PageSize: 5,
      });
      runInAction(() => {
        this.emailAlertDetails = {
          ...this.emailAlertDetails,
          data: searchDetails.data,
          isloading: false,
        };
      });
    } catch (error) {
      this.emailAlertDetails = {
        ...this.emailAlertDetails,
        isloading: false,
      };
    }
  };

  triggerRejectNotification = async (payload: EmailNew) => {
    try {
      const response = await agent.email.rejectNotification(payload);
      runInAction(() => {
        if (response.status === 200) {
          toast.info('Mail Triggered successfully.');
        } else {
          toast.error('Mail failed to send.');
        }
      });
    } catch (error) {
      toast.error('Mail failed to send.');
      console.log('Mail Trigger failed due to', error);
    }
  };
}
